namespace $ {
	$mol_style_define($mynamespace_myapp_app, {
		Greeting: {
			font: {
				size: '1.5rem',
			},
			padding: $mol_gap.block,
			color: $mol_theme.special,
		},
		Profile_id: {
			font: {
				family: 'monospace',
				size: '.85rem',
			},
			opacity: 0.7,
		},
		Profile_status: {
			padding: $mol_gap.block,
			color: $mol_theme.special,
		},
	})
}
